








































import Vue from 'vue'
import { LOAD_MASTER_DATA_QCQ_QUALITY, EDIT_MASTER_DATA_QCQ_QUALITY } from '@/store/action-types'
import { Quality } from '@/model/qcq/Quality'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'

interface ComponentData {
  saveLoading: boolean
  starsItems: Array<number>
  starsNumber: number
  competence: boolean
  employee: boolean
  qualityData: Quality | undefined
  isSaveButtonDisabled: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  isEditable: boolean
}

export default Vue.extend({
  name: 'QcqQualityPage',

  data (): ComponentData {
    return {
      saveLoading: false,
      starsItems: [1, 2, 3, 4, 5],
      starsNumber: 1,
      competence: false,
      employee: false,
      qualityData: undefined,
      isSaveButtonDisabled: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      isEditable: true
    }
  },

  watch: {
    competence (newVal: boolean): void {
      if (newVal) {
        this.employee = false
      }
    },

    employee (newVal: boolean): void {
      if (newVal) {
        this.competence = false
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  methods: {
    async onSaveButtonClick (): Promise<void> {
      this.saveLoading = true

      const payload: Quality = Quality.createFromQcqQualityData(
        this.competence,
        this.employee,
        this.starsNumber,
        this.isEditable
      )
      try {
        await this.$store.dispatch(EDIT_MASTER_DATA_QCQ_QUALITY, payload)
        this.saveLoading = false
        this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
      } catch (e) {
        this.saveLoading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }

  },

  async mounted () {
    this.qualityData = await this.$store.dispatch(LOAD_MASTER_DATA_QCQ_QUALITY)
    if (this.qualityData) {
      this.starsNumber = this.qualityData.numbersOfStars
      this.competence = this.qualityData.competences
      this.employee = this.qualityData.employees
      this.isEditable = this.qualityData.isEditable
      if (!this.qualityData.isEditable) {
        this.isSaveButtonDisabled = true
      }
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
